module.exports = __webpack_public_path__ + "static/media/6.question_loop.764bfb1e.mp4";